import React from "react";
import PropTypes from "prop-types";
import { Box, HStack, Pressable, Text, VStack } from "native-base";
import { FiPlus } from "react-icons/fi";
import Cell from "../cell";
import colors from "../../constants/colors";

function AddLocation(props) {
  const { label, onPress } = props;

  return (
    <tr>
      <Cell>
        <VStack height="inherit" width={10} alignItems="center">
          <Box
            width="2px"
            height="full"
            backgroundColor={colors.third}
            position="absolute"
            left="19px"
            bottom={0}
            alignSelf="center"
            zIndex={0}
          />
        </VStack>
      </Cell>
      <Cell>
        <Pressable marginY={3} onPress={onPress}>
          <HStack>
            <FiPlus color={colors.primary} size={20} />
            <Text color={colors.primary} fontSize="md">
              {label}
            </Text>
          </HStack>
        </Pressable>
      </Cell>
    </tr>
  );
}

AddLocation.propTypes = {
  label: PropTypes.string.isRequired,
  onPress: PropTypes.func.isRequired,
};

export default React.memo(AddLocation);
